module.exports = __webpack_public_path__ + "img/视频封面9.e8d9c0cc.png";